<h4 mat-dialog-title>
  Edit Employee - {{ this.data.firstName }} {{ this.data.lastName }}
</h4>
<div mat-dialog-content>
  <div class="d-flex mb-3">
    <label class="mr-2"><b>Skillset</b></label>
  </div>
  <div class="d-flex mb-3" *ngIf="!isSameEmp">
    <label class="d-flex mr-2">
      <span class="mr-2"><b>SME</b></span><input type="checkbox" [(ngModel)]="this.isSme" class="form-control" />
    </label>
    <mat-select multiple [(ngModel)]="this.data.sme" *ngIf="this.isSme">
      <mat-option *ngFor="let smeskill of SMETechlist" [value]="smeskill">{{
        smeskill
        }}</mat-option>
    </mat-select>
  </div>

  <div class="d-flex mb-3" *ngIf="isAdmin && !isSameEmp">
    <span class="mr-2"><b>Make as admin</b></span><input type="checkbox" [(ngModel)]="isAdminSelected" />
  </div>
</div>
<div mat-dialog-actions>
  <button type="button" class="btn btn-warning btn-custom_warning ml-2 mr-2 deleteButton" mat-dialog-close
    (click)="cancel()">
    Cancel
  </button>
  <button type="button" class="btn btn-success btn-custom_success ml-2 mr-2 deleteButton" mat-dialog-close
    (click)="confirm()">
    Update
  </button>
</div>